export default function copyFormValues() {
  const isPresent = document.querySelectorAll('.c-contact-form, .c-blog-newsletter-form')

  isPresent.forEach((form) => {
    function updateFormValues(form) {
      const parent = form.parentNode.parentNode.parentNode;
      const initialName = parent.querySelector('.js-initial-form-name')
      const initialEmail = parent.querySelector('.js-initial-form-email')
      const initialPhone = parent.querySelector('.js-initial-form-phone')

      const targetName = parent.querySelector('.js-form-name input')
      const targetEmail = parent.querySelector('.js-form-email input')
      const targetPhone = parent.querySelector('.js-form-phone input')

      const targetNameLabel = parent.querySelector('.js-form-name label')
      const targetEmailLabel = parent.querySelector('.js-form-email label')
      const targetPhoneLabel = parent.querySelector('.js-form-phone label')

      const smallLabelFields = parent.querySelectorAll('.ginput_container_checkbox, .ginput_container_select');
      const hiddenLabelFields = parent.querySelectorAll('.ginput_container_consent');



      function updateName() {
        targetName.value = this.value

        if (this.value !== '') {
          targetNameLabel.classList.add('js-label-focused')
        } else {
          targetNameLabel.classList.remove('js-label-focused')
        }
      }

      function updateEmail() {
        targetEmail.value = this.value

        if (this.value !== '') {
          targetEmailLabel.classList.add('js-label-focused')
        } else {
          targetEmailLabel.classList.remove('js-label-focused')
        }
      }

      function updatePhone() {
        targetPhone.value = this.value

        if (this.value !== '') {
          targetPhoneLabel.classList.add('js-label-focused')
        } else {
          targetPhoneLabel.classList.remove('js-label-focused')
        }
      }

      if (initialName) {
        initialName.addEventListener('input', updateName)
      }
      if (initialEmail) {
        initialEmail.addEventListener('input', updateEmail)
      }
      if (initialPhone) {
        initialPhone.addEventListener('input', updatePhone)
      }


      smallLabelFields.forEach((wrap) => {
        wrap.previousSibling.classList.add('js-label-focused')
      })

      hiddenLabelFields.forEach((wrap) => {
        wrap.previousSibling.classList.add('js-label-hidden')
      })

    }

    updateFormValues(form)

    jQuery(document).bind('gform_post_render', function(){
      updateFormValues(form)
    });

  })

}
